<template>
  <v-app>
    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container fluid fill-height align-start >
        <v-dialog
            :value="alertnuevo"
            persistent
            max-width="380"
        >
          <v-card color="#393E46">
            <v-card-title class="text-h5">
              {{ $t('alertas.titulodatos') }}
            </v-card-title>
            <v-card-text>{{ $t('alertas.nuevalista') }}</v-card-text>
            <v-card-actions>
              <v-btn
                  color="green darken-1"
                  text
                  @click="alertnuevo = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>

        <v-dialog v-model="dialogdelete" persistent max-width="350">
          <v-card color="#393E46">
            <v-card-title class="headline">Desea eliminar esta Persona de la Lista?</v-card-title>
            <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="close">No</v-btn>
              <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row justify="center" align="center"><v-col cols="12" lg="8">
         <v-card color="#393E46"><v-card-title> <v-row align="center" class="text-center">
            <v-col cols="12" sm="12" md="12" lg="12">
              <h1  class="display-1 font-weight-bold">
                Hola {{usuario.nombre}}
              </h1>
            </v-col>
          </v-row></v-card-title>
        <v-card-text>  <v-row  justify="space-between">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-form  ref="form">
                <v-row>
                  <v-col  cols="12" sm="12" md="12">
                    <v-autocomplete  v-model="fiestaId" :items="fiestas" item-value="id" item-text="nombre"  persistent-hint

                                     single-line label="Escoger Fiesta"></v-autocomplete>
                  </v-col>
                  <v-col  cols="12" sm="12" md="12">
                    <v-autocomplete  v-model="tipoListaId" :items="tipolistas"  @change="dameMaximos" item-value="tipoLista.id" item-text="tipoLista.tipoListaNombre"  persistent-hint

                                     single-line label="Escoger Tipo Lista"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea v-model="nombres" @change="vernombres" auto-grow rows="6" outlined placeholder="COPIA Y PEGA LOS NOMBRES"></v-textarea>
                  </v-col>

                </v-row>
                <v-row>
                  <v-col>
                    <p>Cantidad Maxima :  {{cantmax.cantidadmaxima}}</p>
                    <p>Cantidad en Lista Actualmente: {{cantmax.cantidadactual}}</p>
                    <p>Posibles :{{cantmax.posibles}}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-alert
                        :value="alerterror"
                        color="red"
                        dark
                        dismissible
                        border="top"
                        transition="scale-transition"
                    >
                      {{texterror}}
                    </v-alert>
                    <v-btn  :disabled="botn"   @click="save">Grabar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row> </v-card-text>
         </v-card></v-col></v-row>
        <leftsinmenupromotor />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
    <piepagina />
  </v-app>
</template>

<script>
import axios from 'axios';
import moment from "moment";
import leftsinmenupromotor from "@/components/general/leftsinmenupromotor";
import {mapGetters} from "vuex";
import firebase from 'firebase/compat/app';
import Piepagina from "@/components/general/piepagina";
export default {
  name: "lista",
  components: {
    Piepagina,
    leftsinmenupromotor
  },
  metaInfo() {
    return {
      title: this.titulonegocio,
      meta: [
        {property: "og:image", content: this.logoimg},
        {property: "og:image:width", content: "699"},
        {property: "og:image:height", content: "366"},
        {
          property: "og:description",
          content: "Lista de  "+this.titulonegocio
        }
      ]
    }
  },
  data () {
    return{
      negocitag: '',
      nombres:'',
      token:'',
      tipoListaId:0,
      fiestaId:0,
      overlay:false,
      cantidad:0,
      alerterror:false,
      texterror:'',
      cantmax:{
        cantidadmaxima: 'Elija Fiesta y Tipo de Lista para obtener la cantidad',
        cantidadactual:'',
        posibles:''
      },
      maximo: 0,
      alertnuevo:false,
      logoexist: false,
      logoimg: null,
      progr:false,
      mostrarlista:true,
      search: '',

      botn: false,
      editedIndex: -1,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      headers: [
        { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Fiesta', align: 'left',  value: 'listaFiesta.fiesta.nombre'},
        { text: 'Fecha', value: 'listaFiesta.fiesta.fechaInicio' },
        { text: 'Dia', value: 'listaFiesta.fiesta.dia.dia' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Tipo de Lista', value: 'listaFiesta.tipoLista.tipoListaNombre'},
        { text: 'Codigo para Registro', value: 'codigoUnico'},
      ],
      promotor:{},
      fiestas: [],
      dialogdelete: false,
      tipolistas:[],
      listas:[],
      lista:{},
      editedItem: {
        id:0,
        listaFiesta:{
          id:0,
          titular:'',
          promotor:{},
          tipoLista:{},
          fiesta:{},
          createdAt: '2020-01-01 00:00:00'
        },
        nombre:'',
        codigoUnico:'',
        personaId:0,
        fechaIngreso:null,
        f:false,
        createdAt: '2020-01-01 00:00:00'
      },

    }
  }
  ,
  mounted (){
    this.negocitag =  this.$route.params.idnegocio;
    if(this.usuario.id>0){
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

    this.damepromotor();
    }else{
      this.$router.push({ path: '/' });

    }
  }
  ,

  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    editItem (item) {
      this.editedIndex = this.listas.indexOf(item)
      this.lista = Object.assign({}, item)
      this.editedItem.listaFiesta.fiesta.fiestaInicio = this.formatDate(new Date(this.editedItem.listaFiesta.fiesta.fiestaInicio))
      this.editedItem.dateCreated = this.formatDateee(new Date(this.editedItem.dateCreated))
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.listas.indexOf(item);
      this.dialogdelete = true;
    },
    vernombres(){
      let maximo = this.cantmax.posibles;
      var arraycad = this.nombres.split(/\r?\n/)
      this.nombres = ""
      var nmb = 0;
      if(arraycad.length< maximo){
        nmb = arraycad.length
      }else{
        nmb = maximo
      }

      for(let i=0;i<nmb;i++){
        if(i === nmb-1){
          this.nombres = this.nombres + arraycad[i]
        }else{
          this.nombres = this.nombres + arraycad[i] + "\r\n"
        }
      }
      if(arraycad.length> maximo){
      this.texterror="Su lista sobrepasa la cantidad de nombres permitida, se recorto a lo posible"
        this.alerterror = true
      }
    },

    save () {
      this.overlay = true;
      this.vernombres()
      var bodyFormData = new FormData();

      bodyFormData.append("promotorId",this.promotor.id);
      bodyFormData.append("fiestaId",this.fiestaId);
      bodyFormData.append("tipoListaId",this.tipoListaId);
      bodyFormData.append("nombres",this.nombres);
      axios
          .post('lista/fiesta/nuevo',bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {
        this.listas=response.data
        this.mostrarlista = false
        this.alertnuevo = true;
        this.overlay = false;
        this.dameMaximos();
        this.$refs.form.reset()
      })
          .catch(error => {
            this.error = "Hubo un error";
            this.overlay = false;
            console.log(error);
          });
    },
    formatDarete (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD HH:mm:ss")
    },
    damefiestas(){
      this.overlay = true
      let urlfiesta = 'promotores/fiestas';
      var bodyFormData = new FormData();

      bodyFormData.append("promotorId",this.promotor.id);

      axios
          .post(urlfiesta,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.fiestas = response.data;
            this.overlay = false;
            this.dametipolistas()
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false;
          });
    },
    damepromotor(){
      this.overlay = true
      var bodyFormData = new FormData();
      bodyFormData.append("tag",this.negocitag);
      bodyFormData.append("personaId",this.usuario.id);
      axios
          .post('promotores/lista',bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.promotor = response.data;
            console.log("promotor");
            console.log(this.promotor)
            this.editedItem.listaFiesta.promotor = this.promotor
            this.damefiestas()
            this.overlay = false
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
          });
    },

    borralo (){
      this.overlay = true
      axios
          .delete('lista/'+ this.listas[this.editedIndex].codigoUnico,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.dialogdelete = false;
            this.listas=response.data
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.error(error);
            this.overlay = false
          });
    },
    dameMaximos(){
      let urlfiesta = 'promotores/maximos';
      var bodyFormData = new FormData();
      let fiest = this.fiestas.find(x=>x.id ===this.fiestaId)
      let fechamax = this.formatDateee(fiest.fechaInicio+' '+fiest.horaPromotorCierre)
      let hoy = this.formatDateee(new Date());
      if (fechamax <= hoy ){
        this.botn = true
      }else{
        this.botn = false
      }
      bodyFormData.append("personaId",this.promotor.id);

      bodyFormData.append("fiestaId",this.fiestaId);
      bodyFormData.append("tipoListaId",this.tipoListaId);
      if(this.tipoListaId>0 && this.promotor.id>0 && this.fiestaId>0){
        this.overlay = true

        axios
            .post(urlfiesta,bodyFormData,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            })
            .then(response => {
              this.cantmax = response.data;
              this.maximo = this.cantmax.posibles
              this.overlay = false;
            })
            .catch((error)  => {
              console.error(error);
              this.overlay = false;
            });
      }
    },
    dametipolistas(){
      this.overlay = true;
      axios
          .get('promotortipolistas/promotor/'+this.promotor.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.tipolistas = response.data;
            this.overlay = false
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
          });
    }
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario"
    })
  }
}
</script>

<style scoped>

</style>